import { render } from "./TexteComponents.vue?vue&type=template&id=9921bc62"
import script from "./TexteComponents.vue?vue&type=script&lang=js"
export * from "./TexteComponents.vue?vue&type=script&lang=js"

import "./TexteComponents.vue?vue&type=style&index=0&id=9921bc62&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__